import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { creditCardItemRepository } from '@webapp/modules/accounts-payable/data-access/repositories/CreditCardItemRepository'
import { RECONCILE_SESSION_MATCHES_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/reconcileSessionQueries'

interface AttachInvoiceItem {
  id: number
  /** Existing packing_slips + the new invoice UUID, appended */
  packingSlipUuids: string[]
}

interface AttachInvoiceVariables {
  items: AttachInvoiceItem[]
}

// Command only (CQS). One PATCH per selected item appends the file UUID to the
// item's packing_slips (BHV-048); on success the matched list refetches.
export const useMutateAttachInvoiceToItems = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, AttachInvoiceVariables>({
    mutationFn: async ({ items }) => {
      await Promise.all(
        items.map((item) =>
          creditCardItemRepository.attachInvoice(item.id, item.packingSlipUuids)
        )
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: RECONCILE_SESSION_MATCHES_BASE_KEY,
      })
    },
  })

  return {
    attach: mutation.mutateAsync,
    isAttaching: mutation.isLoading,
    error: mutation.error,
  }
}
